import { render } from "./index.vue?vue&type=template&id=17fd28ea"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/organisms/transition-type-category/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17fd28ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17fd28ea', __exports__)) {
    api.reload('17fd28ea', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=17fd28ea", () => {
    api.rerender('17fd28ea', render)
  })

}


export default __exports__